import { useBreakpointValue } from "@chakra-ui/react";

export const useResponsiveWidth = () => {
  return useBreakpointValue({
    base: "100%", 
    sm: "540px",
    md: "720px",
    lg: "960px",
    xl: "1152px",
    xxl: "1344px",
    xxxl: "1536px",
  });
};